// Save only a fully received file, after exact-run completion is confirmed.
export function saveCalculationFile(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
export function calculationFilename(response, kind) {
  const disposition = response.headers?.get('content-disposition') || '';
  const match = disposition.match(
    /filename\*?=(?:UTF-8'')?["']?([^";]+)["']?/i
  );
  if (match) {
    try {
      return decodeURIComponent(match[1]);
    } catch {
      return match[1];
    }
  }
  return kind === 'circularity'
    ? 'Circularity results.xlsx'
    : 'Intermediate calculations.zip';
}
